import { render, staticRenderFns } from "./BadgeLabelList.vue?vue&type=template&id=2b79ed9f&"
import script from "./BadgeLabelList.vue?vue&type=script&lang=js&"
export * from "./BadgeLabelList.vue?vue&type=script&lang=js&"
import style0 from "./BadgeLabelList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports